<template lang="html">
  <div class="container-fluid _verification_page">
    <div class="col-sm p-0">
      <div class="row m-0 afterverify_page align-items-center justify-content-center">
        <div class="text-center">
          <img src="@/assets/image/icon/verified.svg" alt="">
          <h5>
            <a href="javascript:void(0)"> {{auth.email}} </a> Has Been Verified. Now Please Re-Login and Upload All Document Required (SIUP, KTP, NPWP, NIB) in the Setting Menu.
          </h5>
          <div class="text-center mt-4">
            <router-link to="/">
              <button type="button" class="_global__button--redcorporite pl-4 pr-4">
                Click Here to Re-Login
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: '',
  mounted () {
    this.params = this.$route.query.code
    const payload = {
      verifcode: this.params
    }
    this.$store.dispatch('auth/AUTH_VERIFY', payload)
  },
  computed: {
    ...mapGetters({
      auth: 'auth/items',
      error: 'auth/error',
      isLoading: 'auth/isLoading'
    })
  }

}
</script>



// WEBPACK FOOTER //
// src/view/verifyEmail/index.vue